import { render, staticRenderFns } from "./BlipCampaignsTable.vue?vue&type=template&id=546035c4&scoped=true&"
import script from "./BlipCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./BlipCampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipCampaignsTable.vue?vue&type=style&index=0&id=546035c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546035c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
